export default __webpack_public_path__ + "static/media/developer-logotype-l.2052a237.svg";